import Keycloak from 'keycloak-js'
const AUTH_URL = `${process.env.VUE_APP_AUTH_BASE_URL}`;

const _initOptions = {
    url: AUTH_URL,
    realm: "am",
    clientId: 'conta',
    onLoad:'login-required'
}

const _keycloak = Keycloak(_initOptions);

export const keycloak = {
    instance: _keycloak,
    init: () => {
        return _keycloak.init({ onLoad: _initOptions.onLoad, promiseType: 'native' });
    }
};
